import { css } from 'styled-components';
import token from 'styled-token';
import { StyledTabList } from '../../components/TabList/TabList.styles';
import { StyledTabPanel } from '../../components/TabPanel/TabPanel.styles';
import { TABS_APPEARANCES } from '../../constants';
var fileTabCSS = function fileTabCSS(props) {
  var appearance = props.appearance,
    fluid = props.fluid;
  if (appearance !== TABS_APPEARANCES.file) {
    return '';
  }
  return token({
    borderColor: 'Button.tertiary.borderColor',
    borderRadius: 'Button.borderRadius',
    borderWidth: 'Button.borderWidth'
  }, function (_ref) {
    var borderColor = _ref.borderColor,
      borderRadius = _ref.borderRadius,
      borderWidth = _ref.borderWidth;
    return css(["", "{border-bottom:0;}", "{border:", "px solid ", ";", "}"], StyledTabList, StyledTabPanel, borderWidth, borderColor, fluid ? '' : "border-top-right-radius: " + borderRadius + "px;");
  })(props);
};

/** @class TabsMixin */
/** @method */
export var TabsMixin = function TabsMixin(props) {
  return css(["", ""], fileTabCSS(props));
};